<ul *ngIf="_items.length">
  <ng-container *ngFor="let item of _items">
    <li *ngIf="item.display(item.control)">
      <strong>{{ item.label }}:</strong>
      {{ item.formatter(item.control.value) }}
    </li>
  </ng-container>
</ul>
